import {Box, Center, Text} from "@chakra-ui/react";

export default function TemperatureBox(props) {
    
    var dateTime = new Date(props.createdDateTime);

    return(
        <Box borderWidth='5px' borderColor='#0052cc' height={props.boxViewHeight} backgroundColor='#3385ff' marginLeft='1vw' marginRight='1vw' 
            fontFamily='sans-serif' minHeight="300px">
            <Center height="100%">
                <Box>
                    <Center>
                        <Text fontSize='3xl' fontWeight='semi-bold' color='white'>{props.poolName}</Text>
                    </Center>
                    <Center>
                        <Text fontSize='75px' fontWeight='bold' color='white'>{props.poolTemperature}&#176;c</Text>
                    </Center>
                    <Center>
                        <Text fontSize='xl' fontWeight='bold' color='white'>Temperature updated at: {dateTime.toLocaleDateString('en-AU')} {dateTime.toLocaleTimeString('en-AU')}</Text>
                    </Center>
                    {props.notes &&
                        <Center>
                            <Text fontSize='xl' fontWeight='bold' color='white'>Note: {props.notes}</Text>
                        </Center>
                    }
                </Box>
            </Center>
        </Box>
    )
}